import { useMutation, useQuery } from './urqlHooks';

const GET_ACTIVE_BANNERS = `
  query GET_ACTIVE_BANNERS {
    activeBanners {
      id
      title
      message
      channel
      scheduledAt
      linkUrl
      linkLabel
    }
  }
`;

export const GetActiveBanners = ({ pause = false, requestPolicy = 'network-only' } = {}) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_ACTIVE_BANNERS,
    pause,
    requestPolicy,
    pollInterval: 60000,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const DISMISS_BANNER = `
  mutation DISMISS_BANNER($bannerId: String!, $companyId: String) {
    dismissBanner(bannerId: $bannerId, companyId: $companyId)
  }
`;

export const DismissBanner = () => {
  const [result, executeMutation] = useMutation(DISMISS_BANNER);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const TRACK_BANNER_LINK_CLICK = `
  mutation TRACK_BANNER_LINK_CLICK($bannerId: String!, $companyId: String) {
    trackBannerLinkClick(bannerId: $bannerId, companyId: $companyId)
  }
`;

export const TrackBannerLinkClick = () => {
  const [result, executeMutation] = useMutation(TRACK_BANNER_LINK_CLICK);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

export const resolveBannerChannel = (banner) =>
  banner?.channel || (Array.isArray(banner?.channels) ? banner.channels[0] : 'BANNER');
